<!--Vista para mostrar el detalle del evento-->
<template>
  <v-container
    fluid
    class="pa-0"
    :class="(!this.currentEvent.darkMode)?'grey lighten-3':'dark-mode-1'"
  >
    <v-row justify="center" class="mb-5">
      <v-col cols="12" class="py-0">
        <!-- SECCIÓN DE LA IMÁGEN DEL EVENTO -->
        <div class="img-gradient"></div>
        <v-row
          justify="start"
          align="center"
          class="pa-0 pos-relative mx-0"
          :class="(socialMediaItems.length===0 && contactDetailsIcons.webSite=='')?'banner-container-small':'banner-container'"
        >
          <v-img
            v-if="currentEvent.eventImage!=''"
            :src="currentEvent.eventImage"
            lazy-src="https://picsum.photos/id/11/10/6"
            class="banner-img"
          ></v-img>
          <div v-else class="banner-img" v-bind:style="organizerBackground"></div>
          <v-col cols="12" sm="7" md="8" lg="7" xl="6" class="text-center pa-0 banner-content">
            <v-card class="pa-0">
              <v-container
                fluid
                class="pa-0"
                :class="(!currentEvent.darkMode)?'primary':'dark-mode-2'"
              >
                <v-row justify="center" align="center" class="pa-0">
                  <v-col cols="12" sm="6" class="white--text">
                    <v-row justify="center" align="center">
                      <v-col
                        cols="8"
                        sm="10"
                        md="10"
                        class="px-0"
                        v-if="startEventDate[3] == endEventDate[3] && startEventDate[1] == endEventDate[1]"
                      >
                        <h2 class="display-2 font-weight-bold white--text">
                          <span class="secondary--text">{{ ('0'+startEventDate[1]).slice(-2)}}</span>
                          de {{ startEventDate[3] }} {{ startEventDate[5] }}
                        </h2>
                      </v-col>
                      <v-col
                        cols="8"
                        sm="10"
                        md="10"
                        class="px-0"
                        v-else-if="startEventDate[3] == endEventDate[3]"
                      >
                        <h2 class="display-2 font-weight-bold white--text">
                          Del
                          <span class="secondary--text">{{ ('0'+startEventDate[1]).slice(-2)}}</span> al
                          <span class="secondary--text">{{ ('0'+endEventDate[1]).slice(-2) }}</span>
                          de {{ startEventDate[3] }}
                        </h2>
                      </v-col>
                      <v-col cols="8" sm="10" md="10" class="px-0" v-else>
                        <h2 class="display-2 font-weight-bold white--text">
                          Del
                          <span class="secondary--text">{{ ('0'+startEventDate[1]).slice(-2)}}</span>
                          de {{ startEventDate[3] }} al
                          <span class="secondary--text">{{ ('0'+endEventDate[1]).slice(-2) }}</span>
                          de {{ endEventDate[3] }}
                        </h2>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="10" sm="6" class="pa-1 pa-lg-5 white">
                    <v-row>
                      <v-col cols="12">
                        <h1 class="text-center display-2 font-weight-bold">{{ currentEvent.name }}</h1>
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="user.role!='ORGANIZER' && currentEvent.estatus === 'ACTIVE'"
                      >
                        <v-row justify="center">
                          <v-btn
                            :disabled="ticketsOutOfStock"
                            color="accent"
                            class="black--text font-weight-bold"
                            :to="urlCheckout()"
                            large
                          >{{ buttonText }}</v-btn>
                        </v-row>
                      </v-col>
                      <v-col cols="12" v-if="currentEvent.estatus != 'ACTIVE'">
                        <h1
                          class="text-center display-2 font-weight-bold red--text"
                        >El evento no esta disponible</h1>
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="user.role!='ORGANIZER' && currentEvent.estatus != 'ACTIVE'"
                      >
                        <v-row justify="center">
                          <v-btn
                            color="accent"
                            class="black--text font-weight-bold"
                            to="/eventos"
                            large
                          >Explorar más eventos</v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <!-- SECCIÓN DE LA IMÁGEN DEL EVENTO -->

        <!-- FECHA Y NOMBRE DEL EVENTO EN MÓVILES -->
        <v-row justify="center">
          <v-col
            cols="12"
            sm="7"
            md="8"
            lg="7"
            xl="6"
            class="text-center pa-0 banner-content-mobile"
          >
            <v-card class="pa-0">
              <v-container
                fluid
                class="pa-0"
                :class="(!currentEvent.darkMode)?'primary':'dark-mode-2'"
              >
                <v-row justify="center" align="center" class="pa-0">
                  <v-col cols="12" sm="6" class="white--text">
                    <v-row justify="center" align="center">
                      <v-col
                        cols="8"
                        sm="10"
                        md="10"
                        class="px-0"
                        v-if="startEventDate[3] == endEventDate[3] && startEventDate[1] == endEventDate[1]"
                      >
                        <h2 class="display-2 font-weight-bold white--text">
                          <span class="secondary--text">{{ ('0'+startEventDate[1]).slice(-2)}}</span>
                          de {{ startEventDate[3] }} {{ startEventDate[5] }}
                        </h2>
                      </v-col>
                      <v-col
                        cols="8"
                        sm="10"
                        md="10"
                        class="px-0"
                        v-else-if="startEventDate[3] == endEventDate[3]"
                      >
                        <h2 class="display-2 font-weight-bold white--text">
                          Del
                          <span class="secondary--text">{{ ('0'+startEventDate[1]).slice(-2)}}</span> al
                          <span class="secondary--text">{{ ('0'+endEventDate[1]).slice(-2) }}</span>
                          de {{ startEventDate[3] }}
                        </h2>
                      </v-col>
                      <v-col cols="8" sm="10" md="10" class="px-0" v-else>
                        <h2 class="display-2 font-weight-bold white--text">
                          Del
                          <span class="secondary--text">{{ ('0'+startEventDate[1]).slice(-2)}}</span>
                          de {{ startEventDate[3] }} al
                          <span class="secondary--text">{{ ('0'+endEventDate[1]).slice(-2) }}</span>
                          de {{ endEventDate[3] }}
                        </h2>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="10" sm="6" class="pa-1 pa-lg-5 white">
                    <v-row>
                      <v-col cols="12">
                        <h1 class="text-center display-2 font-weight-bold">{{ currentEvent.name }}</h1>
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="user.role!='ORGANIZER' && currentEvent.estatus === 'ACTIVE'"
                      >
                        <v-row justify="center">
                          <v-btn
                            :disabled="ticketsOutOfStock"
                            color="accent"
                            class="black--text font-weight-bold"
                            :to="urlCheckout()"
                            large
                          >{{ buttonText }}</v-btn>
                        </v-row>
                      </v-col>
                      <v-col cols="12" v-if="currentEvent.estatus != 'ACTIVE'">
                        <h1
                          class="text-center display-2 font-weight-bold red--text"
                        >El evento no esta disponible</h1>
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="user.role!='ORGANIZER' && currentEvent.estatus != 'ACTIVE'"
                      >
                        <v-row justify="center">
                          <v-btn
                            color="accent"
                            class="black--text font-weight-bold"
                            to="/eventos"
                            large
                          >Explorar más eventos</v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <!-- FECHA Y NOMBRE DEL EVENTO EN MÓVILES -->

        <!-- AMENIDADES Y DATOS DE CONTACTO -->
        <v-row justify="center">
          <v-col
            v-if="currentEvent.amenities.length>0"
            class="pa-5 pa-md-10 white--text text-center"
            :class="(!currentEvent.darkMode)?'primary':'dark-mode-2'"
          >
            <h1 class="headline font-weight-bold mb-2">Amenidades</h1>
            <v-chip
              v-for="amenity in currentEvent.amenities"
              :key="amenity.id"
              class="pa-4 ma-2"
              color="secondary"
            >
              <v-avatar left>
                <v-icon v-bind:style="getSmallSize">{{ amenities[amenity] }}</v-icon>
              </v-avatar>
              {{ amenity }}
            </v-chip>
          </v-col>
          <v-col
            v-if="contactDetailsItems.length>0"
            class="pa-5 pa-md-10 white--text text-center"
            :class="(!currentEvent.darkMode)?'primary':'dark-mode-2'"
          >
            <h1 class="headline font-weight-bold mb-2">Datos de contacto</h1>
            <span v-for="(item, index) in contactDetailsItems" :key="index" class="mr-3">
              <v-icon class="mr-1" color="accent" v-bind:style="getSmallSize">{{ item.icon }}</v-icon>
              {{ item.value }}
            </span>
            <a
              v-if="currentEvent.contactDetails && currentEvent.contactDetails.webSite!=''"
              :href="(currentEvent.contactDetails.webSite.includes('http'))?`${currentEvent.contactDetails.webSite}`: `http://${currentEvent.contactDetails.webSite}`"
              target="_blank"
              class="mr-3 white--text"
            >
              <v-icon
                left
                color="accent"
                v-bind:style="getSmallSize"
              >{{ contactDetailsIcons.webSite }}</v-icon>Sitio web
            </a>
          </v-col>
        </v-row>
        <!-- AMENIDADES Y DATOS DE CONTACTO -->
        <!-- DESCRIPCIÓN DEL EVENTO -->
        <v-row justify="center">
          <v-col cols="10" class="pa-0">
            <v-card
              style="width:100%;"
              class="pa-0"
              :dark="(!this.currentEvent.darkMode)?false:true"
            >
              <v-row justify="center" class="event-content mb-10">
                <v-col cols="12" class="pb-0">
                  <v-row
                    justify="center"
                    class="py-3 py-md-10"
                    data-aos="zoom-in"
                    data-aos-duration="400"
                  >
                    <v-col cols="11" sm="10">
                      <h1 class="display-2 font-weight-bold">Detalles generales</h1>
                    </v-col>
                    <!--INICIO Parche para evento de CMIC Quitar en enero del 2022-->
                    <v-col v-if="$route.params.id=='60d3ca6c24a1bf0007906b7c'" cols="11" sm="10">
                      <p class="headline font-weight-bold"><span class="red--text"><i class="fas fa-exclamation-triangle"></i> ATENCIÓN:</span> Solo se aceptarán DOS afiliados por empresa.</p>
                    </v-col>
                    <!--FIN Parche para evento de CMIC Quitar en enero del 2022-->
                    <v-col
                      v-if="currentEvent.modality=='ON_SITE'"
                      cols="11"
                      sm="10"
                      data-aos="fade-up"
                      data-aos-duration="400"
                    >
                      <h1 class="headline font-weight-bold">Lugar</h1>
                      <p>{{ currentEvent.address.name }}</p>
                    </v-col>

                    <!-- FECHA Y HORA DEL EVENTO -->
                    <v-col
                      cols="11"
                      sm="10"
                      data-aos="fade-up"
                      data-aos-duration="400"
                      v-if="this.currentEvent.startDate"
                    >
                      <h1 class="headline font-weight-bold">Fecha y hora</h1>
                      <p
                        v-if="currentEvent.startDate!='' && formatedStartDate==formatedEndDate"
                      >El día {{formatedStartDate}} de {{ currentEvent.startTime }} a {{ currentEvent.endTime }}.</p>
                      <p
                        v-else
                      >Del día {{ formatedStartDate }} al día {{ formatedEndDate }} de {{ currentEvent.startTime }} a {{ currentEvent.endTime }}.</p>
                    </v-col>
                    <!-- FECHA Y HORA DEL EVENTO -->

                    <!-- REDES SOCIALES -->
                    <v-col
                      v-if="socialMediaItems.length>0"
                      cols="11"
                      sm="10"
                      data-aos="fade-up"
                      data-aos-duration="400"
                    >
                      <h1 class="headline font-weight-bold">Redes sociales</h1>
                      <a
                        v-for="(item, index) in socialMediaItems"
                        :key="index"
                        :href="(item.value.includes('http'))?`${item.value}`: `http://${item.value}`"
                        target="_blank"
                        :rel="`social-${index}`"
                      >
                        <p
                          class="text-capitalize"
                          :class="(currentEvent.darkMode)?'white--text':''"
                        >
                          <v-icon left color="accent" v-bind:style="getSmallSize">{{ item.icon }}</v-icon>
                          {{ item.name }}
                        </p>
                      </a>
                    </v-col>
                    <!-- REDES SOCIALES -->

                    <!-- INICIO de Parche para FEMMEDE (Quitar en diciembre del 2020) ELIMINAR CUANDO EL EVENTO HAYA PASADO-->
                    <v-col
                      cols="11"
                      sm="10"
                      data-aos="fade-up"
                      data-aos-duration="400"
                      v-if="$route.params.id=='5f6523e45ff84b000812d423'"
                    >
                      <v-btn color="#1d6b89" dark href="https://wechamber-organizations-files.s3.us-east-2.amazonaws.com/FEMMEDE/Programa+Preliminar+V2.pdf" target="_blank">Programa preliminar</v-btn>
                    </v-col>
                    <!-- FIN de Parche para FEMMEDE (Quitar en diciembre del 2020) ELIMINAR CUANDO EL EVENTO HAYA PASADO-->
                    <!-- CONTENIDO PERSONALIZADO DEL EVENTO -->
                    <v-col
                      v-if="currentEvent.details!=''"
                      cols="11"
                      sm="10"
                      data-aos="fade-up"
                      data-aos-duration="400"
                    >
                      <h1 class="headline font-weight-bold mb-3">Descripción del evento</h1>
                      <span class="event-custom-content" v-html="currentEvent.details"></span>
                    </v-col>
                    <!-- CONTENIDO PERSONALIZADO DEL EVENTO -->

                    <!-- SEATS.IO -->
                    <!-- <v-col cols="12">
                      <v-row justify="center">
                        <v-col cols="11" sm="10">
                          <h2 class="headline">
                            Distribución del lugar
                          </h2>
                        </v-col>
                        <v-col cols="11" md="10" lg="8" xl="6">
                          <v-col cols="12" md="10" lg="12" class="primary pa-3">
                            <div id="chart" class="white"></div>
                          </v-col>
                        </v-col>
                      </v-row>
                    </v-col>-->
                    <!-- SEATS.IO -->

                    <!-- INICIO de Parche para FEMMEDE (Quitar en diciembre del 2020) ELIMINAR CUANDO EL EVENTO HAYA PASADO-->
                    <v-col
                      cols="11"
                      sm="10"
                      data-aos="fade-up"
                      data-aos-duration="400"
                      v-if="$route.params.id=='5f6523e45ff84b000812d423'"
                    >
                      <v-btn color="#1d6b89" dark href="https://wechamber-organizations-files.s3.us-east-2.amazonaws.com/FEMMEDE/Congreso+FEMMEDE.+Descriptivo+patrocinios+(stands).pdf" target="_blank">Quiero ser patrocinador</v-btn>
                    </v-col>
<!--
                    <v-col
                      cols="10"
                      md="8"
                      data-aos="fade-up"
                      data-aos-duration="400"
                      class="mb-3"
                      v-if="$route.params.id=='5f6523e45ff84b000812d423'"
                    >
                      <v-img
                        :src="currentEvent.eventFlyer"
                        height="auto"
                        max-height="500px"
                        width="100%"
                        contain
                      ></v-img>
                    </v-col>

                    <v-col
                      cols="10"
                      md="8"
                      data-aos="fade-up"
                      data-aos-duration="400"
                      class="mb-3"
                      v-if="$route.params.id=='5f6523e45ff84b000812d423'"
                    >
                      <v-img
                        :src="currentEvent.eventFlyer"
                        height="auto"
                        max-height="500px"
                        width="100%"
                        contain
                      ></v-img>
                    </v-col>

                    <v-col
                      cols="10"
                      md="8"
                      data-aos="fade-up"
                      data-aos-duration="400"
                      class="mb-3"
                      v-if="$route.params.id=='5f6523e45ff84b000812d423'"
                    >
                      <v-img
                        :src="currentEvent.eventFlyer"
                        height="auto"
                        max-height="500px"
                        width="100%"
                        contain
                      ></v-img>
                    </v-col>

                    <v-col
                      cols="10"
                      md="8"
                      data-aos="fade-up"
                      data-aos-duration="400"
                      class="mb-3"
                      v-if="$route.params.id=='5f6523e45ff84b000812d423'"
                    >
                      <v-img
                        :src="currentEvent.eventFlyer"
                        height="auto"
                        max-height="500px"
                        width="100%"
                        contain
                      ></v-img>
                    </v-col>
-->
                    <!-- FIN de Parche para FEMMEDE (Quitar en diciembre del 2020) ELIMINAR CUANDO EL EVENTO HAYA PASADO-->

                    <!-- FLYER DEL EVENTO -->
                    <v-col
                      cols="10"
                      md="8"
                      data-aos="fade-up"
                      data-aos-duration="400"
                      class="mb-3"
                      v-if="currentEvent.eventFlyer && currentEvent.eventFlyer!=''"
                    >
                      <v-img
                        :src="currentEvent.eventFlyer"
                        height="auto"
                        max-height="500px"
                        width="100%"
                        contain
                      ></v-img>
                    </v-col>
                    <!-- FLYER DEL EVENTO -->

                    <!-- PREGUNTAS FRECUENTES DEL EVENTO -->
                    <v-col
                      cols="11"
                      sm="10"
                      data-aos="fade-up"
                      data-aos-duration="400"
                      v-if="currentEvent.faqs.length>0 && currentEvent.faqs[0].question!=''"
                    >
                      <h1 class="headline font-weight-bold mb-3">Preguntas frecuentes</h1>
                      <faq-panel :questions="currentEvent.faqs"></faq-panel>
                    </v-col>
                    <!-- PREGUNTAS FRECUENTES DEL EVENTO -->
                  </v-row>

                  <v-row justify="center" class="text-center mb-10">
                    <v-col
                      v-if="currentEvent.socialMedia.youtube != ''"
                      cols="10"
                      md="5"
                      lg="5"
                      style="flex-wrap:wrap"
                      class="mb-10 mb-md-10"
                      data-aos="fade-right"
                      data-aos-duration="400"
                    >
                      <h1 class="headline font-weight-bold mb-5">Video publicitario</h1>
                      <iframe
                        width="100%"
                        v-bind:style="getVideoHeight"
                        :src="getVideoLink"
                        frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      ></iframe>
                    </v-col>
                    <!-- VIDEO DEL EVENTO -->
                  </v-row>

                  <!-- PATROCINADORES -->
                  <v-row
                    justify="center"
                    v-if="currentEvent.sponsors.length>0 && currentEvent.sponsors.length<13"
                    class="grey lighten-2 text-center py-10 mx-0"
                  >
                    <v-col cols="12">
                      <h2 class="display-1 font-weight-bold mb-8">Nuestros patrocinadores</h2>
                    </v-col>
                    <v-col
                      cols="4"
                      md="3"
                      lg="2"
                      v-for="(sponsor, index) in currentEvent.sponsors"
                      :key="index"
                    >
                      <v-row justify="center" align="center" class="fill-height">
                        <img :src="sponsor" class="sponsor-img" />
                      </v-row>
                    </v-col>
                  </v-row>
                  <!-- PATROCINADORES -->

                  <!-- CARRUSEL PATROCINADORES -->
                  <v-row
                    justify="center"
                    v-else-if="currentEvent.sponsors.length>12"
                    class="grey lighten-2 text-center py-10 mx-0"
                  >
                    <v-col lg="12">
                      <v-window v-model="page" :show-arrows="true">
                        <v-window-item v-for="n in pages" :key="`page-${n}`">
                          <v-row justify="center">
                            <v-col
                              cols="6"
                              sm="3"
                              md="3"
                              v-for="(sponsor, index) in paginatedData"
                              :key="index"
                              class="pa-0 pa-sm-3"
                            >
                              <v-row justify="center" align="center" class="fill-height">
                                <img :src="sponsor" class="sponsor-img-carousel" />
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-window-item>
                      </v-window>
                    </v-col>
                  </v-row>
                  <!-- CARRUSEL PATROCINADORES -->

                  <v-row v-if="currentEvent.modality=='ON_SITE'||currentEvent.modality=='HYBRID'">
                    <!-- TARJETA PARA MAPA DEL EVENTO -->
                    <v-col
                      cols="12"
                      class="px-3 py-0"
                      v-if="googleMapsPosition.hasOwnProperty('lat')"
                    >
                      <map-card :position="googleMapsPosition" :dark="(currentEvent.darkMode)"></map-card>
                    </v-col>
                    <!-- TARJETA PARA EL MAPA DEL EVENTO -->
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import mapCard from "@/components/landing/map-card";
import videoCard from "@/components/landing/video-card";
//import imageCard from "@/components/landing/image-card";
import faqPanel from "@/components/landing/faq-panel";
import { mapState, mapMutations, mapActions } from "vuex";
import * as Vibrant from "node-vibrant";
import { Base64 } from "js-base64";

export default {
  components: {
    mapCard,
    faqPanel
  },
  data() {
    return {
      autorun: true,
      itemsPerPage: 4,
      page: 1,
      googleMapsPosition: {},
      startEventDate: [],
      endEventDate: [],
      formatedStartDate: "",
      formatedEndDate: "",
      socialMediaIcons: {
        facebook: "fab fa-facebook-square",
        twitter: "fab fa-twitter-square",
        linkedin: "fab fa-linkedin",
        instagram: "fab fa-instagram"
      },
      contactDetailsIcons: {
        webSite: "fas fa-globe",
        tel: "fas fa-phone",
        email: "fas fa-envelope"
      },
      amenities: {
        Estacionamiento: "fas fa-car",
        "Coffee break": "fas fa-coffee",
        Alimentos: "fas fa-utensils",
        Constancia: "fas fa-scroll",
        "Aire acondicionado": "fas fa-wind",
        Cóctel: "fas fa-cocktail",
        "Valet Parking": "fas fa-parking",
        "Zona Comercial": "fas fa-hands-helping",
        "Carrera Atlética": "fas fa-running",
        "Rifa de Automóviles": "fas fa-car",
        Conciertos: "fas fa-music",
        Conferencias: "fas fa-microphone-alt"
      },
      organizerBackground: "",
      buttonText: ""
    };
  },
  computed: {
    ...mapState("event", ["event", "currentEvent", "ticketsOutOfStock"]),
    ...mapState("user", ["inEventDetail", "user"]),
    /**
     * Función que devuelve la cantidad de páginas dependiendo de la cantidad de items
     * que se deseen mostrar (itemsPerPage).
     */
    pages() {
      return this.itemsPerPage
        ? Math.ceil(this.currentEvent.sponsors.length / this.itemsPerPage)
        : 0;
    },
    /**
     * Función que devuelve los patrocinadores dependiendo de la página seleccionada.
     */
    paginatedData() {
      const temp = this.page + 1;
      const subItems = this.currentEvent.sponsors.slice(
        temp * this.itemsPerPage - this.itemsPerPage,
        temp * this.itemsPerPage
      );
      return subItems;
    },
    /**
     * Función que da formato a las redes sociales que se presentan en el evento
     */
    socialMediaItems() {
      let data = [];
      for (let item in this.currentEvent.socialMedia) {
        if (
          this.currentEvent.socialMedia[item] != "" &&
          item != "youtube" &&
          item != "__typename"
        )
          data.push({
            name: item,
            value: this.currentEvent.socialMedia[item],
            icon: this.socialMediaIcons[item]
          });
      }
      return data;
    },
    /**
     * Función que da formato a los datos de contacto que se presentan en el evento
     */
    contactDetailsItems() {
      let data = [];
      for (let item in this.currentEvent.contactDetails) {
        if (
          this.currentEvent.contactDetails[item] != "" &&
          item != "webSite" &&
          item != "__typename"
        )
          data.push({
            name: item,
            value: this.currentEvent.contactDetails[item],
            icon: this.contactDetailsIcons[item]
          });
      }
      return data;
    },
    /**
     * Función que toma el tamaño de la pantalla del dispositivo para dar tamaño a los iconos
     */
    getSmallSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size:1.2em";
        case "sm":
          return "font-size:1em";
        case "md":
          return "font-size:1em";
        case "lg":
          return "font-size:1.1em";
        case "xl":
          return "font-size:1.3em";
      }
    },
    /**
     * Función que sirve para poner la altura del contenedor del video de youtube
     */
    getVideoHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "height:200px";
        case "sm":
          return "height:250px";
        case "md":
          return "height:300px";
        case "lg":
          return "height:350px";
        case "xl":
          return "height:400px";
      }
    },
    /**
     * Función para formatear url del video de youtube
     */
    getVideoLink() {
      let youtubeId = "";
      if (
        this.currentEvent.socialMedia &&
        this.currentEvent.socialMedia.youtube
      ) {
        if (
          this.currentEvent.socialMedia.youtube.startsWith("https://youtu.be/")
        )
          youtubeId = this.currentEvent.socialMedia.youtube.split(
            "https://youtu.be/"
          )[1];
        else {
          if (this.currentEvent.socialMedia.youtube.includes("?v="))
            youtubeId = this.currentEvent.socialMedia.youtube.split("?v=")[1];
          else if (this.currentEvent.socialMedia.youtube.includes("&v="))
            youtubeId = this.currentEvent.socialMedia.youtube.split("&v=")[1];
        }

        youtubeId = youtubeId.split("&")[0];
        return `https://www.youtube.com/embed/${youtubeId}`;
      }
    }
  },
  methods: {
    ...mapActions("event", ["fetchEventDetails"]),
    ...mapMutations("event", ["setTicketsOutOfStock"]),
    ...mapMutations("loader", ["loading", "loaded"]),
    /**
     * Función para poner un color degradado de fondo en el encabezado, 
     * en caso de que el organizador no cuente con imagen de encabezado.
     * LA IMAGEN QUE SE TOMA PARA PONER EL COLOR DE FONDO DEL DEGRADADO ES LA DE PERFIL DE ORGANIZADOR.
     */
    async getOrganizerBackground() {
      let newImg = `${
        this.currentEvent.organizer.profilePicture
      }?q=${Date.now()}`;
      let { LightVibrant, DarkVibrant } = await Vibrant.from(newImg)
        .maxColorCount(2)
        .getPalette();
      this.organizerBackground = `content: linear-gradient(315deg, ${LightVibrant.hex} 0%, ${DarkVibrant.hex} 74%);`;
    },
    /**
     * Función para dar formato a fecha del evento
     */
    getEventDate() {
      this.formatedStartDate = this.formatDate(this.currentEvent.startDate);
      this.formatedEndDate = this.formatDate(this.currentEvent.endDate);
      this.startEventDate = this.formatedStartDate.split(" ");
      this.endEventDate = this.formatedEndDate.split(" ");
    },
    /**
     * Función para dar formato con texto a fecha del evento
     */
    formatDate(date) {
      let options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      };

      let adjustedDate = new Date(date);
      adjustedDate.setHours(adjustedDate.getHours() + 12);

      let newDate = new Date(adjustedDate)
        .toLocaleDateString("es-MX", options)
        .replace(",", "");

      return newDate.charAt(0).toLowerCase() + newDate.slice(1);
    },
    /**
     * Función para agregar mapa de asientos al detalle de asiento
     */
    configureSeats() {
      let chart = new seatsio.SeatingChart({
        divId: "chart",
        // LLAVE PÚBLICA DE LA CUENTA
        publicKey: "c78ed0ad-ebeb-4fe1-aafe-887cd9fff0e6",
        // CLAVE DEL EVENTO (HACE REFERENCIA AL MAPA)
        event: "7eafac21-6864-470c-b4f5-9d0a8f9abfff",
        // IDIOMA DE TODOS LOS COMPONENTES DEL IFRAME
        language: "es",
        // PERMITE MOSTRAR EL MAPA DEL EVENTO EN MODO DE SOLO LECTURA
        mode: "print"
      }).render();
    },
    /**
     * Función para validar disponibilidad del evento mediante los boletos disponibles
     */
    isTicketsOutOfStock() {
      this.currentEvent.tickets.forEach(ticket => {
        if (
          ticket.inventory.quantity > ticket.inventory.sold ||
          ticket.inventory.inventoryType == "INFINITE"
        ) {
          this.setTicketsOutOfStock(false);
          return;
        }
      });
    },
    /**
     * Función para obtiener url del checkout, (se usa cuando se da click en el botón de adquirir acceso).
     */
    urlCheckout() {
      let formattedUrl = this.$route.fullPath.split("?");
      return `${formattedUrl[0]}/checkout`;
    }
  },
  async mounted() {
    // CONFIGURE SEATS PERMITE AGREGAR EL MAPA AL EVENTO EN UNA VERSIÓN DE SOLO LECTURA
    // this.configureSeats();
    this.loading();
    await this.fetchEventDetails(this.$route.params.id);
    await this.isTicketsOutOfStock();
    // Texto de botón por default
    this.buttonText = "Adquirir acceso";
    //if (this.$route.params.id == "601c44ead689f90008e03fe8"){
    //  this.buttonText = "Adquirir paquete";
    //}
    // Si no hay boletos disponibles cambiar texto del botón
    if (this.ticketsOutOfStock) {
      this.buttonText = "Accesos agotados";
    }
    // Quitar formato de base 64 en preguntas frecuentes
    this.currentEvent.faqs.forEach(faq => {
      faq.answer = Base64.decode(faq.answer);
    });
    // Quitar preguntas frecuentes que estan en blanco
    for (let i = 0; i < this.currentEvent.faqs.length; i++) {
      if (this.currentEvent.faqs[i].question == "") {
        this.currentEvent.faqs.splice(i, 1);
      }
    }
    // Quitar formato de base 64 en detalles del evento
    this.currentEvent.details = Base64.decode(this.currentEvent.details);
    this.getEventDate();
    await this.getOrganizerBackground();
    // Obtener ubicación del evento y ponerla en el mapa
    this.googleMapsPosition = this.currentEvent.address
      ? {
          lat: this.currentEvent.address.lat,
          lng: this.currentEvent.address.lng
        }
      : null;
    this.loaded();
  },
  created() {
    setInterval(() => {
      if (!this.autorun) return;
      if (++this.page >= this.pages) this.page = 0;
    }, 4000);
  },
  beforeDestroy() {
    this.setTicketsOutOfStock(true);
  }
};
</script>
<style scoped>
a {
  text-decoration: none !important;
}
.event-custom-content >>> h1,
h2,
h3,
h4 {
  font-weight: 700 !important;
}
.event-custom-content >>> blockquote {
  border-left: 4px solid #ccc !important;
  margin-bottom: 5px !important;
  margin-top: 5px !important;
  padding-left: 16px !important;
}
.banner-container {
  position: relative;
}
.img-gradient {
  position: absolute;
  background: rgb(0, 0, 0);
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.65) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  z-index: 1;
}
.sponsor-img {
  filter: grayscale(1);
  height: auto;
  max-height: 100px;
  width: 100%;
  max-width: 150px;
  transition: 0.2s all ease-in-out;
}
.sponsor-img:hover {
  transform: scale(1.35);
}
.sponsor-img-carousel {
  filter: grayscale(1);
  height: auto;
  width: 100%;
  transition: 0.2s all ease-in-out;
}
.sponsor-img-carousel:hover {
  transform: scale(1.5);
}
.event-content {
  margin-top: 35px;
}
@media (max-width: 399px) {
  .img-gradient {
    display: none;
  }
  .sponsor-img {
    max-height: 90px;
    max-width: 130px;
  }
  .sponsor-img-carousel {
    max-height: 100px;
    max-width: 140px;
  }
  .banner-img,
  .banner-container {
    height: 200px !important;
    width: 100% !important;
  }
  .banner-content {
    display: none;
  }
  .banner-content-mobile {
    display: block;
  }
}
@media (min-width: 400px) and (max-width: 599px) {
  .img-gradient {
    display: none;
  }
  .sponsor-img {
    max-height: 90px;
    max-width: 130px;
  }
  .sponsor-img-carousel {
    max-height: 100px;
    max-width: 140px;
  }
  .banner-img,
  .banner-container {
    height: 200px !important;
    width: 100% !important;
  }
  .banner-content {
    display: none;
  }
  .banner-content-mobile {
    display: block;
  }
  .event-custom-content >>> h1 {
    font-size: 1.05em !important;
  }
  .event-custom-content >>> h2 {
    font-size: 1em !important;
  }
  .event-custom-content >>> h3 {
    font-size: 0.95em !important;
  }
}
@media (min-width: 600px) and (max-width: 959px) {
  .img-gradient {
    height: 450px;
    width: 100%;
  }
  .sponsor-img {
    max-height: 90px;
    max-width: 130px;
  }
  .sponsor-img-carousel {
    max-height: 100px;
    max-width: 140px;
  }
  .banner-img,
  .banner-container {
    height: 450px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    transition: 0.13s all ease-in-out;
    bottom: 50px;
    z-index: 2;
  }
  .banner-content-mobile {
    display: none;
  }
  .event-custom-content >>> h1 {
    font-size: 1em !important;
  }
  .event-custom-content >>> h2 {
    font-size: 0.95em !important;
  }
  .event-custom-content >>> h3 {
    font-size: 0.9em !important;
  }
}
@media (min-width: 960px) and (max-width: 1263px) {
  .img-gradient {
    height: 570px;
    width: 100%;
  }
  .sponsor-img {
    max-height: 90px;
    max-width: 130px;
  }
  .sponsor-img-carousel {
    max-height: 100px;
    max-width: 150px;
  }
  .banner-img,
  .banner-container {
    height: 570px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    transition: 0.13s all ease-in-out;
    bottom: 50px;
    z-index: 2;
  }
  .banner-content-mobile {
    display: none;
  }
  .event-custom-content >>> h1 {
    font-size: 1.2em !important;
  }
  .event-custom-content >>> h2 {
    font-size: 1em !important;
  }
  .event-custom-content >>> h3 {
    font-size: 0.9em !important;
  }
}
@media (min-width: 1264px) and (max-width: 1599px) {
  .img-gradient {
    height: 570px;
    width: 100%;
  }
  .sponsor-img {
    max-height: 110px;
    max-width: 150px;
  }
  .sponsor-img-carousel {
    max-height: 150px;
    max-width: 200px;
  }
  .banner-img,
  .banner-container {
    height: 570px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    transition: 0.13s all ease-in-out;
    bottom: 50px;
    z-index: 2;
  }
  .banner-content-mobile {
    display: none;
  }
  .event-custom-content >>> h1 {
    font-size: 1.28em !important;
  }
  .event-custom-content >>> h2 {
    font-size: 1.2em !important;
  }
  .event-custom-content >>> h3 {
    font-size: 1em !important;
  }
}
@media (min-width: 1599px) and (max-width: 1903px) {
  .img-gradient {
    height: 600px;
    width: 100%;
  }
  .sponsor-img {
    max-height: 110px;
    max-width: 150px;
  }
  .sponsor-img-carousel {
    max-height: 160px;
    max-width: 210px;
  }
  .banner-img,
  .banner-container {
    height: 600px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    transition: 0.13s all ease-in-out;
    bottom: 50px;
    z-index: 2;
  }
  .banner-content-mobile {
    display: none;
  }
  .event-custom-content >>> h1 {
    font-size: 1.5em !important;
  }
  .event-custom-content >>> h2 {
    font-size: 1.2em !important;
  }
  .event-custom-content >>> h3 {
    font-size: 1.1em !important;
  }
}
@media (min-width: 1904px) {
  .img-gradient {
    height: 650px;
    width: 100%;
  }
  .sponsor-img {
    max-height: 160px;
    max-width: 200px;
  }
  .sponsor-img-carousel {
    max-height: 200px;
    max-width: 250px;
  }
  .banner-img,
  .banner-container {
    height: 650px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    transition: 0.13s all ease-in-out;
    bottom: 50px;
    z-index: 2;
  }
  .banner-content-mobile {
    display: none;
  }
  .event-custom-content >>> h1 {
    font-size: 1.5em !important;
  }
  .event-custom-content >>> h2 {
    font-size: 1.2em !important;
  }
  .event-custom-content >>> h3 {
    font-size: 1.1em !important;
  }
}
</style>